<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Slide promo</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn depressed color="primary" @click="createItem">
								<v-icon left>mdi-plus</v-icon>
								Nuova slide
							</v-btn>
						</v-toolbar>

						<v-card-text class="pb-0">
							<v-alert outlined text type="info" dense class="mb-0">
								Le slide attive compaiono in cima alla Home di tutti i profili, alte 300px e centrate (formato consigliato 1024×300). Cliccando una slide si apre il suo link.
							</v-alert>
						</v-card-text>

						<v-data-table
							:headers="headers"
							:items="getSlides"
							:loading="loading"
							item-key="_id"
							sort-by="order"
							class="elevation-0"
							no-data-text="Nessuna slide: creane una con Nuova slide"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!-- telefono: ogni riga diventa una card chiave/valore (lo slot body esiste solo su telefono, su desktop restano gli slot item.*) -->
							<template v-if="mobileCards" v-slot:body="{ items }">
								<tbody class="promoslide-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.title || 'Slide'" :fields="campiCard(item)" :image="item.image || ''">
												<template v-slot:actions>
													<v-btn icon small color="primary" @click="editItem(item)">
														<v-icon small>mdi-pencil</v-icon>
													</v-btn>
													<v-btn icon small color="error" @click="deleteItem(item)">
														<v-icon small>mdi-delete</v-icon>
													</v-btn>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Attiva</span>
													<v-switch :input-value="item.active" color="primary" inset dense hide-details class="mt-0 pt-0" @change="toggleActive(item, $event)"></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="items.length === 0">
										<td :colspan="headers.length" class="grey--text text-center py-4">Nessuna slide: creane una con Nuova slide</td>
									</tr>
								</tbody>
							</template>
							<template v-slot:[`item.image`]="{ item }">
								<v-img :src="item.image" width="192" height="56" class="grey lighten-3 my-2 rounded" />
							</template>
							<template v-slot:[`item.link`]="{ item }">
								<span v-if="item.link" class="d-inline-flex align-center">
									<v-icon small class="mr-1">{{ isExternalLink(item.link) ? 'mdi-open-in-new' : 'mdi-arrow-right' }}</v-icon>
									{{ item.link }}
								</span>
								<span v-else class="grey--text">Nessun link</span>
							</template>
							<template v-slot:[`item.active`]="{ item }">
								<v-switch :input-value="item.active" color="primary" inset dense hide-details class="mt-0" @change="toggleActive(item, $event)"></v-switch>
							</template>
							<template v-slot:[`item.actions`]="{ item }">
								<v-btn icon small color="primary" @click="editItem(item)">
									<v-icon small>mdi-pencil</v-icon>
								</v-btn>
								<v-btn icon small color="error" @click="deleteItem(item)">
									<v-icon small>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialog" max-width="960" :retain-focus="false">
			<PromoSlideForm v-if="dialog" :key="formKey" :slide="editing" @close="dialog = false" @saved="onSaved" @error="notify($event, 'error')" />
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="320">
			<v-card>
				<v-card-title class="headline">Eliminare la slide?</v-card-title>
				<v-card-text>La slide sparisce subito dalla Home di tutti i profili e non si può ripristinare.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false">Annulla</v-btn>
					<v-btn color="error" text @click="confirmDelete">Elimina</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :timeout="5000">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar.snackbar = false">Chiudi</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isExternalLink } from '@/components/manage/promoslides/link';
import KeyValueCard from '@/components/core/KeyValueCard.vue';

const PromoSlideForm = () => import('@/components/manage/promoslides/Form.vue');

export default {
	name: 'PromoSlides',
	components: { PromoSlideForm, KeyValueCard },
	data() {
		return {
			loading: false,
			dialog: false,
			dialogconfirm: false,
			editing: null,
			toDelete: null,
			formKey: 0,
			snackbar: { snackbar: false, color: '', text: '' },
			headers: [
				{ text: 'Immagine', value: 'image', sortable: false, width: 220 },
				{ text: 'Titolo', value: 'title' },
				{ text: 'Link', value: 'link', sortable: false },
				{ text: 'Ordine', value: 'order', width: 100 },
				{ text: 'Attiva', value: 'active', width: 100 },
				{ text: '', value: 'actions', sortable: false, align: 'end', width: 110 },
			],
		};
	},
	computed: {
		...mapGetters({
			getSlides: 'promoslides/getSlides',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
	},
	created() {
		this.getDataFromApi();
	},
	methods: {
		...mapActions({
			fetchAll: 'promoslides/fetchAll',
			updateSlide: 'promoslides/update',
			removeSlides: 'promoslides/remove',
		}),
		isExternalLink,
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [
				{ label: 'Link', value: item.link || 'Nessun link' },
				{ label: 'Ordine', value: item.order, strong: true },
			];
		},
		async getDataFromApi() {
			this.loading = true;
			const res = await this.fetchAll();
			this.loading = false;
			if (res && res.error) this.notify(res.status === 403 ? 'Sezione riservata al SuperAdmin' : 'Impossibile caricare le slide', 'error');
		},
		notify(text, color = 'success') {
			this.snackbar = { snackbar: true, color, text };
		},
		createItem() {
			this.editing = null;
			this.formKey += 1;
			this.dialog = true;
		},
		editItem(item) {
			this.editing = { ...item };
			this.formKey += 1;
			this.dialog = true;
		},
		async onSaved(text) {
			this.dialog = false;
			this.notify(text);
			await this.getDataFromApi();
		},
		async toggleActive(item, value) {
			const res = await this.updateSlide({ _id: item._id, active: !!value });
			if (!res || res.error) this.notify('Aggiornamento non riuscito', 'error');
			else this.notify(value ? 'Slide attivata: ora è visibile in Home' : 'Slide disattivata');
			await this.getDataFromApi();
		},
		deleteItem(item) {
			this.toDelete = item;
			this.dialogconfirm = true;
		},
		async confirmDelete() {
			this.dialogconfirm = false;
			if (!this.toDelete) return;
			const res = await this.removeSlides([this.toDelete]);
			this.toDelete = null;
			if (!res || res.error) this.notify('Eliminazione non riuscita', 'error');
			else this.notify('Slide eliminata');
			await this.getDataFromApi();
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.promoslide-cards,
.promoslide-cards tr {
	display: block;
	width: 100%;
}
.promoslide-cards tr,
.promoslide-cards tr:hover {
	background: transparent !important;
}
.promoslide-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.promoslide-cards tr:first-child td {
	padding-top: 12px !important;
}
.promoslide-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.promoslide-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
